module.exports = __webpack_public_path__ + "img/netdocs.653420f0.png";